module.exports = __webpack_public_path__ + "img/payment-channels-blue.cbe44e58.svg";